import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react'

import 'semantic-ui-css/semantic.min.css';
import '../../App.css';

export default class SemanticUiModal extends Component {
 
  render() {
    const { modalOptions, header, content, actions, closeModal } = this.props;
    return (
      <Modal { ...modalOptions } open={ true }>
        { header && <Modal.Header>{ header }</Modal.Header> }
        { content && <Modal.Content>{ content }</Modal.Content> }
        { actions && <Modal.Actions>{ actions }</Modal.Actions> }
        { closeModal && <i className="delete icon" onClick={ closeModal }></i> }
      </Modal>
    );

  }

}



// WEBPACK FOOTER //
// ./src/components/modal/index.js